import React from "react";

import { useSelector } from "react-redux";

import { Mobile2x1Layout } from "components/Layout/ContentHeader";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { SearchHeader } from "components/SearchInput/GlobalSearch";

import { ApiModel } from "constants/loading";

import {
  getCurrentSaleType,
  getHasWriteAccessInCurrentSale,
  selectFilteredSaleLotIds,
} from "selectors";

import { LotCardBySaleLotId } from "components/LotCard";
import { cards, TransactionalSaleTypes } from "constants/sale";
import { MultiButton } from "components/Button";
import {
  useHasAlternativeMobileWorkflowPermission,
  useIsMobile,
  useSetScreenSize,
  useTranslatedSaleTypeText,
} from "hooks";
import {
  getLivestockSaleId,
  getSaleRoute,
  getSaleyardName,
  openEditSaleLotModal,
  openInlineCreateSaleLotModal,
} from "lib/navigation";
import { faDesktop, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { useHistory } from "react-router-dom";
import RenderData from "components/RenderData";

export function SaleLotCardsView() {
  const { setDesktop } = useSetScreenSize();

  const history = useHistory();

  const isMobile = useIsMobile();

  const hasWriteAccessInCurrentSale = useSelector(
    getHasWriteAccessInCurrentSale,
  );

  const hasAlternativeMobileWorkflowPermission =
    useHasAlternativeMobileWorkflowPermission();

  const saleType = useSelector(getCurrentSaleType);

  const isTransactionalSale = TransactionalSaleTypes.includes(saleType);

  const isUsingAlternativeSaleLotForm =
    isMobile && isTransactionalSale && hasAlternativeMobileWorkflowPermission;

  const filteredSaleLotIds = useSelector(selectFilteredSaleLotIds);

  const onClickCreateSaleLot = () =>
    isUsingAlternativeSaleLotForm
      ? openEditSaleLotModal()
      : openInlineCreateSaleLotModal(
          {},
          {
            showDeliveryPen: false,
            includeCreateUnknownConsignment: true,
            includeStoredValues: true,
          },
        );

  const saleTypeText = useTranslatedSaleTypeText("Sale Lot");
  const noSaleLotsText = `No ${saleTypeText}s Yet`;

  const readOnly = !hasWriteAccessInCurrentSale;

  const actionText = readOnly ? "" : `Add ${saleTypeText}`;

  const buttons = [
    {
      title: "Lot",
      isDisabled: readOnly,
      onClick: onClickCreateSaleLot,
      icon: faPlus,
      dataTour: "addSaleLot",
    },
    {
      title: "Desktop View",
      icon: faDesktop,
      onClick: () => {
        setDesktop();
        history.push(
          `${getSaleRoute(getSaleyardName(), getLivestockSaleId())}/salelots`,
        );
      },
      dataTour: "desktopView",
    },
  ];

  return (
    <div>
      <WaitForSync
        requiredData={[
          ApiModel.SALE_LOTS,
          ApiModel.AUCTION_PENS,
          ApiModel.PEN_ARCHETYPES,
        ]}
      >
        <RenderData
          test={!!filteredSaleLotIds.length}
          infoText={noSaleLotsText}
          actionText={actionText}
          dataTour="addSaleLot"
          onClick={onClickCreateSaleLot}
          desktopRedirect="salelots"
        >
          <SearchHeader
            layout={Mobile2x1Layout}
            actionButton={<MultiButton buttons={buttons} />}
          />
          {filteredSaleLotIds.map(saleLotId => {
            return (
              <LotCardBySaleLotId
                key={saleLotId}
                saleLotId={saleLotId}
                cardType={cards.SALE_LOT_CARD}
                showVendor
                showBuyer
                showBuyerWay
                showScanning
              />
            );
          })}
        </RenderData>
      </WaitForSync>
    </div>
  );
}
